<template>
  <div class="fab-container" ref="fabContainer">
    <!-- Main FAB Button -->
    <button 
      class="fab-main" 
      :class="{ 'active': isOpen }"
      @click.stop="toggleMenu"
    >
      <div class="fab-icon">
        <svg v-if="!isOpen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 4v16M4 12h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </button>

    <!-- Menu Items -->
    <transition-group name="fab-menu" tag="div" class="fab-menu-container">
      <button 
        v-if="isOpen"
        v-for="item in menuItems" 
        :key="item.id"
        class="fab-item"
        :class="item.class"
        :data-tooltip="item.name"
        @click.stop="handleAction(item.action)"
      >
        <div class="fab-item-icon" v-html="item.icon"></div>
      </button>
    </transition-group>

    <!-- AI Chat Widget -->
    <!-- <AiChatWidget ref="aiChatWidget" /> -->

  <VueEmbedChatBox
    knowledgeBaseId="3901147f-40d5-4603-9d3f-f7569623164f"
    chatId="5837e5b4-dd38-4c25-886e-433d87afecae"
    src="https://www.docaider.com"
    chatboxTitle="EKU-Linah"
    position="bottom-right"
    theme="green"
    welcomeMessage="Hi there! How can I help you today"
    width="350px"
    height="500px"
  />

  </div>
</template>

<script setup>
// import AiChatWidget from './AIchat.vue'

import { ref, onMounted, onUnmounted } from 'vue'
import { VueEmbedChatBox, useDocaiderEmbed } from 'docaider-embed/vue'

// ... rest of your existing script (menuItems, props, handleAction, etc.)
// The useDocaiderEmbed composable will control this widget instance

const { open: openAI, setWelcomeMessage, useKnowledge } = useDocaiderEmbed()


const props = defineProps({
  position: {
    type: Object,
    default: () => ({
      bottom: '100px',
      right: '20px'
    })
  },
  menuItems: {
    type: Array,
    default: () => [
      {
        id: 1,
        name: 'WhatsApp',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.031 2.016c4.969 0 9 4.031 9 9s-4.031 9-9 9c-1.5 0-2.953-0.375-4.219-1.031l-4.781 1.5 1.5-4.641c-0.75-1.313-1.125-2.813-1.125-4.313 0-4.969 4.031-9 9-9zM12.031 4.031c-3.891 0-6.984 3.094-6.984 6.984 0 1.219 0.328 2.391 0.938 3.422l-0.563 2.203 2.203-0.563c1.031 0.609 2.203 0.938 3.422 0.938 3.891 0 6.984-3.094 6.984-6.984s-3.094-6.984-6.984-6.984zM12.891 12.984c0.141-0.141 0.281-0.141 0.422 0l0.984 0.984c0.328 0.328 0.328 0.844 0 1.172-0.609 0.609-1.172 0.938-2.063 0.938-1.172 0-2.391-0.656-3.094-1.359-0.797-0.797-1.453-2.016-1.453-3.188 0-0.891 0.328-1.453 0.938-2.063 0.328-0.328 0.844-0.328 1.172 0l0.984 0.984c0.141 0.141 0.141 0.281 0 0.422-0.328 0.328-0.703 0.656-0.703 1.078 0 0.516 0.328 1.125 0.703 1.5 0.375 0.375 0.984 0.703 1.5 0.703 0.422 0 0.75-0.375 1.078-0.703z"/></svg>',
        action: 'whatsapp',
        class: 'fab-whatsapp'
      },
      {
        id: 2,
        name: 'AI Help',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>',
        action: 'aiHelp',
        class: 'fab-ai'
      },
      {
        id: 3,
        name: 'Call Us',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>',
        action: 'callUs',
        class: 'fab-call'
      }
    ]
  }
})

const isOpen = ref(false)
const fabContainer = ref(null)
const aiChatWidget = ref(null)

const toggleMenu = () => {
  isOpen.value = !isOpen.value
}

const handleAction = (action) => {
  switch(action) {
    case 'whatsapp':
      window.open('https://wa.me/255745450431', '_blank')
      break
    case 'aiHelp':
      setWelcomeMessage("Welcome to EKU Market! I'm Rose.")
      useKnowledge("Customer Context", { site: "EKU Market" })
      openAI()
      break
    case 'callUs':
      window.location.href = 'tel:+255683195811'
      break
  }
  
  // Close menu after action
  isOpen.value = false
}

// Close menu when clicking outside
const handleClickOutside = (event) => {
  if (fabContainer.value && !fabContainer.value.contains(event.target) && isOpen.value) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* Your existing styles here (same as before) */
.fab-container {
  position: fixed;
  bottom: v-bind('position.bottom');
  right: v-bind('position.right');
  z-index: 1000;
}

.fab-main {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.fab-main:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.fab-main.active {
  transform: rotate(45deg);
  background: linear-gradient(135deg, #B8860B, #DAA520);
}

.fab-icon {
  width: 24px;
  height: 24px;
  color: white;
}

.fab-icon svg {
  width: 100%;
  height: 100%;
}

.fab-menu-container {
  position: absolute;
  bottom: 70px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1;
}

.fab-item {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.fab-item:hover {
  transform: scale(1.1);
}

.fab-item-icon {
  width: 20px;
  height: 20px;
}

.fab-item-icon svg {
  width: 100%;
  height: 100%;
}

.fab-whatsapp {
  background: linear-gradient(135deg, #25D366, #128C7E);
}

.fab-whatsapp svg {
  color: white;
}

.fab-ai {
  background: linear-gradient(135deg, #6366F1, #8B5CF6);
}

.fab-ai svg {
  color: white;
}

.fab-call {
  background: linear-gradient(135deg, #EF4444, #DC2626);
}

.fab-call svg {
  color: white;
}

.fab-menu-enter-active,
.fab-menu-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fab-menu-enter-from,
.fab-menu-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.fab-menu-enter-to,
.fab-menu-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.fab-item::before {
  content: attr(data-tooltip);
  position: absolute;
  right: 60px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.fab-item:hover::before {
  opacity: 1;
}

@media (max-width: 768px) {
  .fab-main {
    width: 48px;
    height: 48px;
  }
  
  .fab-item {
    width: 44px;
    height: 44px;
  }
  
  .fab-item::before {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fab-main,
  .fab-item,
  .fab-menu-enter-active,
  .fab-menu-leave-active {
    transition: none;
  }
}
</style>